import { MEDIA_QUERIES_UPDATE } from './types';

export const triggerMediaQueriesUpdate = (windowWidth) => ({
  type: MEDIA_QUERIES_UPDATE,
  windowWidth,
});
